import { render, staticRenderFns } from "./newAdd.vue?vue&type=template&id=66e83eb7&scoped=true"
import script from "./newAdd.vue?vue&type=script&lang=js"
export * from "./newAdd.vue?vue&type=script&lang=js"
import style0 from "./newAdd.vue?vue&type=style&index=0&id=66e83eb7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e83eb7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66e83eb7')) {
      api.createRecord('66e83eb7', component.options)
    } else {
      api.reload('66e83eb7', component.options)
    }
    module.hot.accept("./newAdd.vue?vue&type=template&id=66e83eb7&scoped=true", function () {
      api.rerender('66e83eb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/route/trunkLineManagement/component/newAdd.vue"
export default component.exports